import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { Collapse, Modal } from 'reactstrap';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import { IAction, IAppState } from '../../../models/action/core';
import { IActivityMultipleProps, IActivityMultipleState } from '../../../models/components/activity-multiple';
import { IFormikProps } from '../../../models/components/activity-multiple';
import { DatetimeFormik } from '../../input/date-time/date-time-formik';
import { SelectNoneAsync } from '../../input/select/main';
import { ActivityType } from '../../../models/enums/ActivityType';
import * as Actions from '../../../store/actions/activityMultiply';
import Moment from 'moment';
import imgAnn from '../../../static/images/announcement.svg';
import { Formik, FormikActions, FormikProps } from 'formik';
import { Confirm } from '../../notification/main';
import Loading from '../../loading/loading';
import ContentLoader from 'react-content-loader';
import * as ActionsCoursePage from '../../../store/actions/coursePage';
import ReactGA from 'react-ga4';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('Activity Multiple');

class CActivityMultiple extends Component<IActivityMultipleProps, IActivityMultipleState, IFormikProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public state: IActivityMultipleState = {
        row2status: false,
        isAll: false,
        disAllowedTermWeekIds: [],
        selectedTermWeekIds: [],
        isModalOpen: false,
        selectedActivityId: '',
        selectedActivityName: '',
        virtualClassStartTime: new Date(),
        isStarted: false,
        isMultiplyResultModalOpen: false,
        emptyStringError: false
    };

    public componentDidUpdate() {
        if (this.props.courseId && this.props.courseId !== -1 && this.props.courseId !== '-1') {
            this.props.dispatch(
                Actions.GetActivityList(
                    this.props.courseId,
                    this.props.classId,
                    '',
                    false,
                    false,
                    9999,
                    0,
                    'week',
                    'getActivitiesForMultiply',
                    'get'
                )
            );
        }
    }

    //  componentDidUpdate(prevProps: IActivityCopyProps) {}

    public onCopy = () => {
        const data = this.getData();

        if (data === '') {
            this.setState({ emptyStringError: true });
        } else {
            Confirm.setConfirm(
                'normal',
                () => this.startMultiply(data),
                T.t('r_activity_multiply_start'),
                null,
                null,
                undefined,
                undefined,
                null,
                null,
                T.t('r_yes'),
                () => this.loadingMultiply()
            );

            this.setState({ isStarted: true });
        }
    };

    getValuesFromInputs = (termWeekId: string) => {
        if (termWeekId === null || termWeekId === '') {
            return '';
        } else {
            const dateTimeItem = document.getElementsByName('targetTermWeekSelect_'.concat(termWeekId.toString()));
            if (dateTimeItem.length < 1 || dateTimeItem[0]!.getAttribute('value')!.toString() === '') {
                return '';
            }

            const actualStartTimeItem = document.getElementById('actualStartTime_'.concat(termWeekId.toString()));
            if (actualStartTimeItem === null || actualStartTimeItem!.getAttribute('value')!.toString() === '') {
                return '';
            }

            const activityNameItem = document.getElementById('activityName_'.concat(termWeekId.toString()));
            if (activityNameItem === null || activityNameItem!.getAttribute('value')!.toString() === '') {
                return '';
            }

            const durationItem = document.getElementById('durationTime_'.concat(termWeekId.toString()));
            if (durationItem === null || durationItem!.getAttribute('value')!.toString() === '') {
                return '';
            }

            const dateTime = dateTimeItem[0]!.getAttribute('value')!.toString();
            const actualStartTime = actualStartTimeItem!.getAttribute('value')!.toString();
            const activityName = activityNameItem!.getAttribute('value')!.toString();
            const duration = durationItem!.getAttribute('value')!.toString();

            return termWeekId + '|' + dateTime + ' ' + actualStartTime + '|' + activityName + '|' + duration + '~';
        }
    };

    public getData = () => {
        var data = '';

        var error = false;

        if (this.state.isAll === true) {
            const weekCheckboxItem = document.getElementsByName('weekCheckbox');
            if (weekCheckboxItem.length < 1) {
                error = true;
                return '';
            } else {
                weekCheckboxItem.forEach(item => {
                    const result = this.getValuesFromInputs(item.getAttribute('value')!.toString());
                    if (result === '') {
                        error = true;
                        return '';
                    } else {
                        data += result;
                    }
                });
            }
        } else {
            this.state.selectedTermWeekIds.map(item => {
                const result = this.getValuesFromInputs(item.toString());
                if (result === '') {
                    error = true;
                    return '';
                } else {
                    data += result;
                }
            });
        }

        data = data.substring(0, data.length - 1);

        return data;
    };

    public startMultiply = async (data: string) => {
        this.props.dispatch(
            Actions.getStartActivityMultiple(data, this.state.selectedActivityId, 'week', 'getStartActivityMultiply', 'set')
        );
    };

    public loadingMultiply = () => {
        var loadingModalDiv = document.createElement('div');
        loadingModalDiv.id = 'processLoading';
        loadingModalDiv.classList.add('row');
        loadingModalDiv.classList.add('modal');
        loadingModalDiv.classList.add('modal-dialog-centered');
        loadingModalDiv.classList.add('fade');

        var loadingDiv = document.createElement('div');
        loadingDiv.classList.add('spinner_bg');

        loadingModalDiv.setAttribute('role', 'dialog');
        loadingModalDiv.tabIndex = -1;

        loadingModalDiv.setAttribute('aria-labelledby', 'exampleModalLabel');
        loadingModalDiv.style.display = 'block';
        loadingModalDiv.style.backgroundColor = 'rgba(0,0,0,0.5)';
        loadingModalDiv.style.padding = '12.5% 35%';
        loadingModalDiv.setAttribute('aria-hidden', 'true');

        loadingModalDiv.appendChild(loadingDiv);

        var donutDiv = document.createElement('div');
        donutDiv.classList.add('donut');

        loadingDiv.appendChild(donutDiv);

        var loadingInnerDiv = document.createElement('span');
        loadingInnerDiv.classList.add('report_title');
        loadingInnerDiv.innerText = T.t('r_duplicating_activities');

        loadingDiv.appendChild(loadingInnerDiv);

        loadingModalDiv.classList.add('show');

        document.body.appendChild(loadingModalDiv);
    };

    selectAll = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            this.setState({ isAll: event.target.checked });
            if (!event.target.checked) {
                this.setState({ disAllowedTermWeekIds: [] });
            }
        }
    };

    onSelectQuestion = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            if (!this.state.isAll) {
                const selectedIds = Object.assign([], this.state.selectedTermWeekIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (event.target.checked && id) {
                    selectedIds.push(id);
                } else if (!event.target.checked && id) {
                    const index = selectedIds.indexOf(id);
                    if (index !== -1) {
                        selectedIds.splice(index, 1);
                    }
                }
                this.setState({ selectedTermWeekIds: selectedIds });
            } else {
                const disAllowedIds = Object.assign([], this.state.disAllowedTermWeekIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (!event.target.checked && id) {
                    disAllowedIds.push(id);
                } else if (event.target.checked && id) {
                    const index = disAllowedIds.indexOf(id);
                    if (index !== -1) {
                        disAllowedIds.splice(index, 1);
                    }
                }
                this.setState({ disAllowedTermWeekIds: disAllowedIds });
            }
        }
    };

    onSubmit = async (values: any, formikActions: FormikActions<any>) => {
        // this.state.filterInitialValues.subject = values.subject;
        // this.state.filterInitialValues.categories =
        //     values.categoryTypeId && values.categoryTypeId.length > 0 ? values.categoryTypeId[0] : '';
        // this.state.filterInitialValues.status = values.statusId && values.statusId.length > 0 ? values.statusId: '';
        // this.state.filterInitialValues.helpDeskCreateDate = values.helpDeskCreateDate ? values.helpDeskCreateDate : '';
        // this.state.filterInitialValues.page = 1;
        // this.setState(this.state)
    };

    triggerModal = () => {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    };

    openModal = (activityId: string, activityName: string, actualStartTime: any) => {
        this.setState({
            selectedActivityId: activityId,
            selectedActivityName: activityName,
            isModalOpen: !this.state.isModalOpen,
            virtualClassStartTime: actualStartTime
        });

        this.props.dispatch(Actions.GetActivityMultiplyData(activityId, '', 'get'));
    };

    triggerMultiplyResultModal = () => {
        this.setState({
            isMultiplyResultModalOpen: !this.state.isMultiplyResultModalOpen
        });
    };

    triggerEmptyStringErrorModal = () => {
        this.setState({
            emptyStringError: !this.state.emptyStringError
        });
    };

    public findTerm(activityTermWeekId: string) {
        if (this.props.termWeeks && this.props.termWeeks!.length > 0) {
            const termWeek = this.props.termWeeks!.find(x => x.termWeekId === activityTermWeekId);
            if (termWeek) {
                const index = this.props.termWeeks!.indexOf(termWeek);
                return this.props.termWeeks![index].week;
            } else return '';
        } else return '';
    }

    public getTermName(activityTermWeekId: string) {
        if (this.props.termWeeks && this.props.termWeeks!.length > 0) {
            const termData = this.findTerm(activityTermWeekId);

            if (termData === null || termData.toString() === '') {
                return '';
            } else {
                return termData.toString() + '. ' + T.t('r_time_week');
            }
        } else return '';
    }

    returnTermWeekArray(termWeekBegin: Date, termWeekEnd: Date) {
        const days = new Array(
            T.t('r_gen_sunday'),
            T.t('r_gen_monday'),
            T.t('r_gen_tuesday'),
            T.t('r_gen_wednesday'),
            T.t('r_gen_thursday'),
            T.t('r_gen_friday'),
            T.t('r_gen_saturday')
        );

        var arr = [{ value: '', label: '' }];

        var beginDate = new Date(termWeekBegin);
        var endDate = new Date(termWeekEnd);

        for (var i = beginDate; i < endDate; i.setDate(i.getDate() + 1)) {
            arr.push({ value: Moment(i).format('DD-MM-YYYY'), label: Moment(i).format('DD-MM-YYYY') + ' - ' + days[i.getDay()] });
        }

        arr = arr.filter(item => item.value !== '');
        return arr;
    }

    returnDefaultTermWeekDay(termWeekBegin: Date, termWeekEnd: Date) {
        if (
            this.state.virtualClassStartTime === null ||
            this.state.virtualClassStartTime === undefined ||
            this.state.virtualClassStartTime === new Date()
        ) {
            return '';
        } else {
            const termWeekDays = this.returnTermWeekArray(termWeekBegin, termWeekEnd);
            var index = 0;
            var result = '';

            termWeekDays.forEach(item => {
                if (item.value !== null && item.value !== undefined && item.value.toString() !== '') {
                    const splitedDate = item.value.toString().split('-');
                    const day = splitedDate[0];
                    const month = splitedDate[1];
                    const year = splitedDate[2];

                    const finalDate = year + '-' + month + '-' + day;
                    var date = new Date(finalDate);

                    var dateVirtualClassStartTime = new Date(this.state.virtualClassStartTime);
                    if (date.getDay() === dateVirtualClassStartTime.getDay()) {
                        result = termWeekDays[index].value;
                    } else {
                        index++;
                    }
                }
            });

            return result;
        }
    }

    public onChangeSelectCondition(selectValue: any, formik: FormikProps<any>) {
        // if (selectValue) {
        //     formik.setFieldValue('status', selectValue.value);
        // }
    }

    dateformik() {}

    changeDuration = (durationId: string, newValue: string) => {
        var item = document.getElementById(durationId);

        if (item === null) {
            return;
        }

        item.setAttribute('value', newValue);
    };

    goToCourse = () => {
        const url =
            window.appSettings.DEFAULT_URL + '/u/course?classId=' + this.props.classId + '&activityId=' + this.props.courseId + '&type=1';
        window.open(url, '_self');
    };

    onClickDiv = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_MULTIPLY_VIRTUAL_CLASS_CLICKED',
            label: 'G_MULTIPLY_VIRTUAL_CLASS_CLICKED',
            nonInteraction: true
        });

        this.setState(prevState => ({ ...prevState, row2status: !prevState.row2status }));
    };

    onClickMultiply = (activity: any) => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_MULTIPLY_ACTIVITY_CLICKED',
            label: 'G_MULTIPLY_ACTIVITY_CLICKED',
            nonInteraction: true
        });

        this.openModal(activity.activityId!, activity.name!, activity.actualStartTime!);
    };

    public render() {
        if (
            this.props.multiplyResultData != null &&
            this.props.multiplyResultData != undefined &&
            this.props.multiplyResultData.success != null &&
            this.state.isStarted
        ) {
            var element = document.getElementById('processLoading');
            if (element != null) {
                element!.classList.remove('show');
                element!.remove();
                this.setState({ isStarted: false });

                this.triggerMultiplyResultModal();
            }
        }

        return (
            <>
                <Collapse isOpen={this.state.row2status}>
                    <div className="row report-row-expanded">
                        <div className="col-12 helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                            <div>
                                <ul className="px-3">
                                    {/* tablo başlık kısmı */}
                                    <li>
                                        <div className="row  align-items-center">
                                            <div className="col-4 d-flex justify-content-start align-items-center">
                                                <b>{T.t('r_gen_activity_name')}</b>
                                            </div>
                                            <div className="col-2">
                                                <b>{T.t('r_current_week')}</b>
                                            </div>
                                            <div className="col-2">
                                                <b>{T.t('r_gen_start_date')}</b>
                                            </div>
                                            <div className="col-2">
                                                <b>{T.t('r_gen_end_date')}</b>
                                            </div>
                                            <div className="col-2 text-center">
                                                <b>{T.t('r_gen_process')}</b>
                                            </div>
                                        </div>
                                    </li>

                                    {/* aktivitelerin listelenmesi */}
                                    <Loading spinnerId={'getActivitiesForMultiply'} height={'calc(100vh - 197px)'}>
                                        <div style={{ backgroundColor: '#fbfaf6', height: '100%' }}>
                                            <ContentLoader
                                                speed={2}
                                                width={'100%'}
                                                height={360}
                                                viewBox="0 0 1440 160"
                                                backgroundColor="#d9d9d9"
                                                foregroundColor="#ededed"
                                            >
                                                <rect x="50" y="6" rx="4" ry="4" width="1440" height="38" />
                                                <rect x="8" y="6" rx="4" ry="4" width="35" height="38" />
                                                <rect x="50" y="55" rx="4" ry="4" width="1440" height="38" />
                                                <rect x="8" y="55" rx="4" ry="4" width="35" height="38" />
                                                <rect x="50" y="104" rx="4" ry="4" width="1440" height="38" />
                                                <rect x="8" y="104" rx="4" ry="4" width="35" height="38" />
                                                <rect x="50" y="153" rx="4" ry="4" width="1440" height="38" />
                                                <rect x="8" y="153" rx="4" ry="4" width="35" height="38" />
                                            </ContentLoader>
                                        </div>
                                    </Loading>

                                    {this.props.courseContentWeekActivities && this.props.courseContentWeekActivities !== undefined ? (
                                        <div className="col-12 page-table helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                                            {this.props.courseActivityList && this.props.courseActivityList.length > 0
                                                ? this.props.courseActivityList
                                                      .filter(item => item.activityType === ActivityType.VirtualClass)
                                                      .map(activity => (
                                                          <li style={{ background: 'none' }} key={activity.activityId}>
                                                              <div className="row  align-items-center">
                                                                  <div className="col-4 d-flex justify-content-start align-items-center">
                                                                      <img
                                                                          className="mr-1"
                                                                          style={{ width: '16px' }}
                                                                          src={_common.GetActivityTypeIcons('virtualclass')}
                                                                          alt="Link Icon"
                                                                      />
                                                                      <span>{activity.name!}</span>
                                                                  </div>
                                                                  <div className="col-2" style={{ fontWeight: '500' }}>
                                                                      {activity.activityId ? this.getTermName(activity.termWeekId!) : ''}
                                                                  </div>
                                                                  <div className="col-2">
                                                                      <div>
                                                                          {Moment(activity.actualStartTime!).format('DD-MM-YYYY HH:mm:ss')}
                                                                      </div>
                                                                  </div>
                                                                  <div className="col-2">
                                                                      <div>
                                                                          {Moment(activity.actualEndTime!).format('DD-MM-YYYY HH:mm:ss')}
                                                                      </div>
                                                                  </div>
                                                                  <div className="col-2">
                                                                      <div>
                                                                          <a
                                                                              className="ml-2 category-tag-square tag-green"
                                                                              onClick={event => this.onClickMultiply(activity)}
                                                                              onKeyDown={event => this.onClickMultiply(activity)}
                                                                          >
                                                                              {T.t('r_activity_multiple_button')}
                                                                          </a>
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                          </li>
                                                      ))
                                                : ''}
                                        </div>
                                    ) : (
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <img style={{ marginTop: '2em', marginBottom: '1em' }} src={imgAnn} />

                                            <h5
                                                id="searched"
                                                className="d-block"
                                                style={{ marginTop: 15, textAlign: 'center', marginBottom: 15 }}
                                            >
                                                {T.t('r_gen_not_created_virtualclass')}
                                            </h5>
                                        </div>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* sanal sınıf aktivitesine basılınca gelecek taşıma modalı */}

                    <Modal
                        className="activity-multiple-modal exam-modal-stats"
                        isOpen={this.state.isModalOpen}
                        toggle={() => this.triggerModal()}
                        style={{ maxWidth: '90vw' }}
                    >
                        <div className="modal-header border-0 d-flex justify-content-between align-items-center mb-2 mb-md-0">
                            <h6
                                className="modal-title d-inline-flex align-items-center"
                                style={{ fontSize: '1em' }}
                                id="avtivityMultipleModal"
                            >
                                <i className="material-icons">flip_to_front</i>
                                &nbsp;
                                {T.t('r_virtual_class_multiple')}
                            </h6>
                            <button type="button" className="close p-0 m-0" onClick={() => this.triggerModal()} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body p-0">
                            <div className="row report-row-expanded mt-0">
                                <div className="col-12 page-table helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                                    <div>
                                        <ul className="px-3" style={{ listStyle: 'none' }}>
                                            {/* tablo başlık kısmı */}
                                            <li>
                                                <div className="row  align-items-center">
                                                    <div className="col-2 d-flex justify-content-start align-items-center">
                                                        <div className="tick-radio position-relative">
                                                            <input
                                                                onChange={this.selectAll}
                                                                type="checkbox"
                                                                checked={this.state.isAll}
                                                                name="demo"
                                                                defaultValue="one"
                                                                id="radio-vc"
                                                                className="form-radio mr-2"
                                                            />
                                                        </div>
                                                        <b>{T.t('r_time_week')}</b>
                                                    </div>
                                                    <div className="col-3">
                                                        <b>{T.t('r_gen_activity_name')}</b>
                                                    </div>
                                                    <div className="col ">
                                                        <b>{T.t('r_time_day')}</b>
                                                    </div>
                                                    <div className="col-2">
                                                        <b>{T.t('r_time')}</b>
                                                    </div>
                                                    <div className="col-2">
                                                        <b>{T.t('r_validation_gen_virtualClassTime')}</b>
                                                    </div>
                                                </div>
                                            </li>

                                            {/* aktivite çoğaltma detay listelenmesi */}

                                            {this.props.termWeeks &&
                                            this.props.termWeeks!.length > 0 &&
                                            this.props.activityMultiplyDataList &&
                                            this.props.activityMultiplyDataList.activityDuration &&
                                            this.props.activityMultiplyDataList.virtualClassTime &&
                                            this.props.courseActivityList &&
                                            this.props.courseActivityList.length > 0 &&
                                            this.state.virtualClassStartTime &&
                                            this.state.virtualClassStartTime !== new Date()
                                                ? this.props
                                                      .termWeeks!.filter(item => this.findTerm(item.termWeekId!) !== 0)
                                                      .map((termWeek, index) => (
                                                          <li style={{ background: 'none' }}>
                                                              <Formik
                                                                  initialValues={{
                                                                      activityName:
                                                                          this.state.selectedActivityName +
                                                                          ' ' +
                                                                          this.findTerm(termWeek.termWeekId!),
                                                                      durationTime: this.props.activityMultiplyDataList!.activityDuration,
                                                                      actualStartTime: this.props.activityMultiplyDataList!.virtualClassTime
                                                                  }}
                                                                  onSubmit={this.onSubmit}
                                                              >
                                                                  {formik => {
                                                                      return (
                                                                          <form
                                                                              onSubmit={formik.handleSubmit}
                                                                              key={'project_add_user_modal'}
                                                                              noValidate={true}
                                                                          >
                                                                              <div className="row  align-items-center">
                                                                                  <div className="col-2 d-flex justify-content-start align-items-center">
                                                                                      <div className="tick-radio position-relative mr-2">
                                                                                          <input
                                                                                              data-id={termWeek.termWeekId!}
                                                                                              onChange={this.onSelectQuestion}
                                                                                              type="checkbox"
                                                                                              name={'weekCheckbox'}
                                                                                              value={termWeek.termWeekId!}
                                                                                              defaultValue="one"
                                                                                              id={'weekCheckbox_'.concat(index.toString())}
                                                                                              checked={
                                                                                                  (!this.state.isAll &&
                                                                                                      this.state.selectedTermWeekIds.includes(
                                                                                                          termWeek.termWeekId!
                                                                                                      )) ||
                                                                                                  (this.state.isAll &&
                                                                                                      !this.state.disAllowedTermWeekIds.includes(
                                                                                                          termWeek.termWeekId!
                                                                                                      ))
                                                                                              }
                                                                                              className="form-radio"
                                                                                              style={{zIndex: "unset"}}
                                                                                          />
                                                                                      </div>

                                                                                      <span>{this.getTermName(termWeek.termWeekId!)}</span>
                                                                                  </div>
                                                                                  <div className="col-3" style={{ fontWeight: '500' }}>
                                                                                      <input
                                                                                          type="text"
                                                                                          className="mt-2 w-90"
                                                                                          id={'activityName_'.concat(
                                                                                              termWeek.termWeekId!.toString()
                                                                                          )}
                                                                                          name="activityName"
                                                                                          style={{ minWidth: '80% !important' }}
                                                                                          placeholder={T.t('r_activity_search_placeholder')}
                                                                                          value={formik.values.activityName}
                                                                                          onChange={formik.handleChange}
                                                                                      />
                                                                                  </div>
                                                                                  <div className="col">
                                                                                      <SelectNoneAsync
                                                                                          isMulti={false}
                                                                                          name={'targetTermWeekSelect_'.concat(
                                                                                              termWeek.termWeekId!.toString()
                                                                                          )}
                                                                                          // touched={this.props.formik.touched.days}
                                                                                          // errors={this.props.formik.errors.days}
                                                                                          // setFieldValue={this.returnTermWeekArray(termWeek.startDate!, termWeek.endDate!)[0]}
                                                                                          setOptions={this.returnTermWeekArray(
                                                                                              termWeek.startDate!,
                                                                                              termWeek.endDate!
                                                                                          )}
                                                                                          onChange={(e: any) =>
                                                                                              this.onChangeSelectCondition(e, formik)
                                                                                          }
                                                                                          // isTouched={this.props.formik.setFieldTouched}
                                                                                          // placeHolder={this.returnTermWeekArray(termWeek.startDate!, termWeek.endDate!)[3].label}
                                                                                          isClearable={false}
                                                                                          // selectedOption={this.returnTermWeekArray(termWeek.startDate!, termWeek.endDate!)[0]}
                                                                                          setSelectValue={[
                                                                                              this.returnDefaultTermWeekDay(
                                                                                                  termWeek.startDate!,
                                                                                                  termWeek.endDate!
                                                                                              )
                                                                                          ]}
                                                                                      />
                                                                                  </div>

                                                                                  <div className="col-2">
                                                                                      <div
                                                                                          className="form-input form-group date-picker"
                                                                                          style={{ marginTop: '8px' }}
                                                                                      >
                                                                                          <DatetimeFormik
                                                                                              name={'actualStartTime'}
                                                                                              formik={formik}
                                                                                              datePickerId={'actualStartTime_'.concat(
                                                                                                  termWeek.termWeekId!.toString()
                                                                                              )}
                                                                                              placeHolder={T.t('r_time')}
                                                                                              mode="time"
                                                                                              time24Hr={true}
                                                                                              static={true}
                                                                                          />
                                                                                      </div>
                                                                                  </div>

                                                                                  <div className="col-2">
                                                                                      <input
                                                                                          type="number"
                                                                                          className="vc_name_input"
                                                                                          id={'durationTime_'.concat(
                                                                                              termWeek.termWeekId!.toString()
                                                                                          )}
                                                                                          name={'durationTime'}
                                                                                          placeholder={T.t(
                                                                                              'r_validation_gen_virtualClassTime'
                                                                                          )}
                                                                                          style={{ minWidth: '80% !important' }}
                                                                                          defaultValue={formik.values.durationTime!}
                                                                                          onChange={event =>
                                                                                              this.changeDuration(
                                                                                                  'durationTime_'.concat(
                                                                                                      termWeek.termWeekId!.toString()
                                                                                                  ),
                                                                                                  event.target.value
                                                                                              )
                                                                                          }
                                                                                      />
                                                                                  </div>
                                                                              </div>
                                                                          </form>
                                                                      );
                                                                  }}
                                                              </Formik>
                                                          </li>
                                                      ))
                                                : ''}
                                        </ul>
                                    </div>

                                    <div className="row" style={{ marginTop: '3em' }}>
                                        <a
                                            onClick={this.onCopy}
                                            className={'ml-2 category-tag-square tag-green '.concat(
                                                this.state.selectedTermWeekIds.length > 0 || this.state.isAll ? '' : 'disabledButton'
                                            )}
                                            style={{ position: 'absolute', right: '1em', bottom: '1em' }}
                                        >
                                            {T.t('r_activity_multiple_button')}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </Collapse>

                <Modal
                    id="multiply-popup"
                    keyboard={false}
                    isOpen={this.state.isMultiplyResultModalOpen}
                    toggle={() => this.triggerMultiplyResultModal()}
                    contentClassName={'modal-dialog  copy-modal-dialog'}
                    modalClassName={''}
                >
                    <div className="modal-header border-0 d-flex justify-content-between ">
                        <h6 className="modal-title d-inline-flex"> {T.t('r_activity_multiply_summary')} </h6>
                        <button
                            onClick={() => this.triggerMultiplyResultModal()}
                            type="button"
                            style={{ border: 'none', background: 'transparent', fontSize: '1.5em' }}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-content ">
                        <div className="modal-body p-0">
                            <div className="row d-flex flex-column justify-content-between" style={{ marginTop: 0, marginBottom: '1em' }}>
                                <div className="multiply_from_to">
                                    <span className="material-icons">check_circle</span>
                                </div>
                                <div className="multiply_success " onClick={() => this.goToCourse()}>
                                    <a>
                                        <span className="material-icons mr-2">output</span>{' '}
                                        {this.props.coursePageclassInformation.courseName}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    id="empty-error-popup"
                    keyboard={false}
                    isOpen={this.state.emptyStringError}
                    toggle={() => this.triggerEmptyStringErrorModal()}
                    contentClassName={'modal-dialog  copy-modal-dialog'}
                    modalClassName={''}
                >
                    <div className="modal-header border-0 d-flex justify-content-between ">
                        <h6 className="modal-title d-inline-flex"> {T.t('r_error')} </h6>
                        <button
                            onClick={() => this.triggerEmptyStringErrorModal()}
                            type="button"
                            style={{ border: 'none', background: 'transparent', fontSize: '1.5em' }}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-content ">
                        <div className="modal-body p-0">
                            <div className="row d-flex flex-column justify-content-between" style={{ marginTop: 0, marginBottom: '1em' }}>
                                <div className="multiply_from_to_fail">
                                    <span className="material-icons">error_outline</span>
                                </div>
                                <div className="multiply_fail">{T.t('r_duplicating_activities_empty_error')}</div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IActivityMultipleProps): IActivityMultipleProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IActivityMultipleProps = Object.assign({}, ownProps, {
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        courseActivityList: state.activityMultiply.courseActivityList,
        courseNames: state.coursePage.activityMultiply,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        termWeeks: state.coursePage.courseContentTermWeeks,
        multiplyResultData: state.activityMultiply.multiplyResultData,
        courseId: state.coursePage.coursePageActivityId,
        activityMultiplyDataList: state.activityMultiply.activityMultiplyDataList
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.activityMultiply.courseActivityList === prev.activityMultiply.courseActivityList &&
        next.coursePage.coursePageclassInformation === prev.coursePage.coursePageclassInformation &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.activityMultiply.multiplyResultData === prev.activityMultiply.multiplyResultData &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.activityMultiply.activityMultiplyDataList === prev.activityMultiply.activityMultiplyDataList
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const ActivityMultiple = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CActivityMultiple);

export default ActivityMultiple;
